<template>
<div id="app">
  <div class="hgroup bigdata">
    <h2 class="depth2-title"><strong>OPEN API</strong></h2>
  </div>
  <div id="content" class="body">
  </div>
</div>

</template>

<script>
export default {
  name: 'DownloadOpenApi'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DownloadOpenApi.vue